window.addEventListener('DOMContentLoaded', () => {

  /* ==========================================
     MOBILE MENU
  ========================================== */

  const toggle = document.querySelector('.tfd-mobile-toggle');
  const menu = document.querySelector('.tfd-nav__menu');

  if (toggle && menu) {

    let scrollPosition = 0;
    let menuOpen = false;

    function openMenu() {
      scrollPosition = window.scrollY;

      menu.classList.add('active');

      document.documentElement.classList.add('tfd-menu-open');
      document.body.classList.add('tfd-menu-open');

      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollPosition}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';

      menuOpen = true;
    }

    function closeMenu() {

      menu.classList.remove('active');

      document.documentElement.classList.remove('tfd-menu-open');
      document.body.classList.remove('tfd-menu-open');

      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';

      window.scrollTo(0, scrollPosition);

      menuOpen = false;
    }

    toggle.addEventListener('click', (e) => {

      e.preventDefault();
      e.stopPropagation();

      menuOpen ? closeMenu() : openMenu();

    });

    menu.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', closeMenu);
    });

    document.addEventListener('click', (e) => {

      if (!menuOpen) return;

      const clickedMenu = menu.contains(e.target);
      const clickedToggle = toggle.contains(e.target);

      if (!clickedMenu && !clickedToggle) {
        closeMenu();
      }

    });

    document.addEventListener('keydown', (e) => {

      if (e.key === 'Escape' && menuOpen) {
        closeMenu();
      }

    });

  }

  /* ==========================================
     THEME TOGGLE
  ========================================== */

  function setTheme(theme) {

    document.documentElement.setAttribute(
      'data-theme',
      theme
    );

    localStorage.setItem(
      'tfd-theme',
      theme
    );

    document
      .querySelectorAll('.tfd-navbar-theme-icon')
      .forEach(icon => {

        icon.textContent =
          theme === 'dark'
            ? '☀️'
            : '🌙';

      });
  }

  const savedTheme =
    localStorage.getItem('tfd-theme') || 'light';

  setTheme(savedTheme);

  /* ==========================================
     EVENT DELEGATION
     Works even if Shopify rerenders sections
  ========================================== */

  document.addEventListener('click', (e) => {

    const btn =
      e.target.closest('.tfd-navbar-theme-toggle');

    if (!btn) return;

    const currentTheme =
      document.documentElement.getAttribute('data-theme') ||
      'light';

    const newTheme =
      currentTheme === 'dark'
        ? 'light'
        : 'dark';

    setTheme(newTheme);

  });

});